import { Action } from '@ngrx/store';

export const CURRENT_PAGE = '[Shared] Current Page';

// todo refactor - drop IS_MOBILE action
export const IS_MOBILE = '[Shared] Is Mobile';
export const DETECT_SCREEN_SIZE = '[Shared] Detect Screen Size';

export class CurrentPage implements Action {
  readonly type = CURRENT_PAGE;

  constructor(public payload: string) {}
}

export class IsMobile implements Action {
  readonly type = IS_MOBILE;

  constructor(public payload: boolean) {}
}

export class DetectScreenSize implements Action {
  readonly type = DETECT_SCREEN_SIZE;
}

export type SharedActions =
  | CurrentPage
  | IsMobile
  | DetectScreenSize;
